import React from 'react';
import localforage from 'localforage';

export const handleExportData = async () => {
  try {
    await localforage.ready();
    const keys = await localforage.keys();
    const dataDump = {};

    for (const key of keys) {
      const value = await localforage.getItem(key);
      dataDump[key] = value;
    }

    const timestamp = new Date()
      .toISOString()
      .replace(/[-:]/g, '')
      .replace('T', '_')
      .split('.')[0];
    const filename = `backup_${timestamp}.json`;

    const jsonData = JSON.stringify(dataDump);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    console.log('LocalForage Database exported to', filename);
  } catch (error) {
    console.error('Error exporting LocalForage database:', error);
  }
};

class LocalForageBackup extends React.Component {
  render() {
    return <button onClick={handleExportData}>Fazer backup</button>;
  }
}

export default LocalForageBackup;
